import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    title: '',
  });
  const [submissionStatus, setSubmissionStatus] = useState(null); // 'success', 'error', null
  const [buttonText, setButtonText] = useState('Send Request'); // 'Send Request', 'Sending...'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonText('Sending...');
    setSubmissionStatus(null);

    Promise.all([
      emailjs.sendForm('service_b3kciu7', 'template_d09gf9z', e.target, 'Tsmx9JfCpJTHSNQKj'), // To customer
      emailjs.sendForm('service_b3kciu7', 'template_7e8eh6q', e.target, 'Tsmx9JfCpJTHSNQKj')  // To business
    ])
      .then(() => {
          setSubmissionStatus('success');
          setButtonText('Send Request');
          setFormData({ name: '', email: '', title: '' });
      }, (error) => {
          console.error('EmailJS error:', error);
          setSubmissionStatus('error');
          setButtonText('Send Request');
      });
  };

  return (
    <section id="contact" className="py-5 rjc-contact-section">
      <Container>
        <h2 className="text-center mb-5 rjc-section-title">Custom Order Request</h2>
        <Row className="justify-content-center">
          <Col md={7}>
            {submissionStatus === 'success' && (
              <Alert variant="success" className="text-center">
                Thank you for your inquiry! We will get back to you shortly.
              </Alert>
            )}
            {submissionStatus === 'error' && (
              <Alert variant="danger" className="text-center">
                There was an error submitting your request. Please try again later.
              </Alert>
            )}
            <Form onSubmit={handleSubmit} className="rjc-contact-form">
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMessage">
                <Form.Label>What would you like to have made?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Describe your custom woodworking project..."
                  name="title"
                  value={formData.title || ''}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="rjc-submit-button">
                {buttonText}
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Contact;